const PREFIX = 'EXAMPLE_FORM_DROPDOWN_CALENDAR_FORM_'

export const EXAMPLE_FORM_DROPDOWN_CALENDAR_FORM_PAGE_REQUEST = `${PREFIX}PAGE_REQUEST`



// WEBPACK FOOTER //
// ./app/actions/example/form/dropdownCalendarForm/constants.js